import videojs from 'video.js';
import type Player from 'video.js/dist/types/player';
import { track } from '~/services/analytics/index.client.ts';
import { getNavItemAnalyticsData } from '~/utils/analytics.tsx';
import { disposePlayerAndNavigate, playerGoBack } from '../utils/index.ts';
import type { FeedEntry } from '~/services/layout/index.ts';

export default function topBarPlugin(
  this: Player,
  {
    playerID,
    title,
    playableItem,
    analyticsTrackData,
    baseURL,
    isContinueWatchingSyncedFeed,
    layoutIdOverride,
  }: {
    playerID: string;
    title: string;
    playableItem: FeedEntry;
    analyticsTrackData: any;
    baseURL: string;
    isContinueWatchingSyncedFeed: boolean;
    layoutIdOverride?: string | null;
  }
) {
  // @ts-ignore
  const player = videojs(playerID);

  // @ts-ignore
  const TitleBar: any = videojs.getComponent('TitleBar');
  const titleBar = new TitleBar(this, {
    className: 'videojs-topbar-title pl-20 pt-5 text-lg vjs-hidden',
  });

  // @ts-ignore
  const Button: any = videojs.getComponent('Button');
  const button = new Button(this, {
    className:
      'videojs-topbar-button top-0 left-0 vjs-visible-text absolute h-auto w-auto p-4 text-sm vjs-hidden',
    clickHandler: () => {
      if (!document.pictureInPictureElement) player.reset();

      const { eventName, trackData } = getNavItemAnalyticsData(
        'tap_navbar_back_button',
        analyticsTrackData
      );

      track(eventName, trackData);

      disposePlayerAndNavigate({
        player,
        isContinueWatchingSyncedFeed,
        navigationFunction: () => {
          playerGoBack({
            baseURL,
            playableItem,
            layoutIdOverride,
          });
        },
      });

      button.el().style.pointerEvents = 'none';
    },
  });

  button.el().innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" class="w-9 h-9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M19 12H5M12 19l-7-7 7-7"/>
    </svg>
  `;

  titleBar.el().textContent = title;

  this.addChild(titleBar);

  const isHistory = window.history.length !== 1;

  if (isHistory) this.addChild(button);

  button.show();
  titleBar.show();

  player.on('useractive', () => {
    button.el().style.transition = 'opacity 0.5s';
    titleBar.el().style.transition = 'opacity 0.5s';

    button.el().style.opacity = '100';
    titleBar.el().style.opacity = '100';
  });

  player.on('pause', () => {
    button.el().style.opacity = '100';
    titleBar.el().style.opacity = '100';
  });

  player.on('userinactive', () => {
    if (player.paused()) return;

    button.el().style.transition = 'opacity 1s';
    button.el().style.opacity = '0';

    titleBar.el().style.transition = 'opacity 1s';
    titleBar.el().style.opacity = '0';
  });
}

/**
 * Hides the top bar plugin elements (title and back button)
 */
export function hideTopBarPlugin() {
  const topbarButtonElement: HTMLElement | null = document.querySelector(
    '.videojs-topbar-button'
  );
  if (topbarButtonElement) {
    topbarButtonElement.style.transition = 'opacity 1s';
    topbarButtonElement.style.opacity = '0';
  }

  const topbarTitleElement: HTMLElement | null = document.querySelector(
    '.videojs-topbar-title'
  );
  if (topbarTitleElement) {
    topbarTitleElement.style.transition = 'opacity 1s';
    topbarTitleElement.style.opacity = '0';
  }
}
